/* eslint-disable jsx-a11y/alt-text */
import { Grid, Box, Typography, Divider } from '@material-ui/core';
import React from 'react';
import { currencyFormatter, simpleDateFormatter2 } from '../Shared/colorFormat';

export class WorkReportPrint extends React.PureComponent<any, any> {
  renderHeader = (company: any) => (
    <Grid item xs={12}>
      <img
        src={company?.header}
        alt={company?.name}
        height="auto"
        width="100%"
        style={{
          objectFit: 'contain',
        }}
      />
      <Divider></Divider>
    </Grid>
  );

  renderTitle = (printData: any) => {
    const { isRTL, start, end } = printData;
    return (
      <Grid item xs={12}>
        <Grid container spacing={0}>
          <Grid item xs={12} style={{ marginBottom: 40, marginTop: 20 }}>
            <Typography style={{ textAlign: 'center' }} variant="h3">
              {isRTL ? 'تقرير العمل' : 'Work Report'}
            </Typography>
          </Grid>
          <Grid item xs={2}>
            <Typography variant="subtitle1">
              {isRTL ? 'التاريخ' : 'Date'}
            </Typography>
          </Grid>
          <Grid item xs={2}>
            <Typography variant="subtitle1">
              {simpleDateFormatter2(start)}
            </Typography>
          </Grid>
          <Grid item xs={2}>
            <Typography variant="subtitle1">
              {simpleDateFormatter2(end)}
            </Typography>
          </Grid>
          <Grid item xs={12} style={{ padding: 10 }}></Grid>
        </Grid>
      </Grid>
    );
  };

  renderItemHeaderTable = (isRTL: boolean) => {
    return (
      <tr style={{ fontSize: 12 }}>
        <th>{isRTL ? 'الموظف' : 'Employee'}</th>
        <th>{isRTL ? 'حاضر' : 'Present'}</th>
        <th>{isRTL ? 'غائب' : 'Absent'}</th>
        <th>{isRTL ? 'إضافي' : 'Overtime'}</th>
        <th>{isRTL ? 'مكافئة' : 'Bonus'}</th>
        <th>{isRTL ? 'خصم' : 'Deduction'}</th>
      </tr>
    );
  };

  renderItemTable = (item: any, isRTL: any) => {
    return (
      <tr style={{ fontSize: 12 }}>
        <td style={{ textAlign: 'center' }}>
          {isRTL ? item?.employeeNameAr : item?.employeeName}
        </td>
        <td style={{ textAlign: 'center' }}>{item?.working}</td>
        <td style={{ textAlign: 'center' }}>{item?.absent}</td>
        <td>{currencyFormatter({ value: item?.overtime })}</td>
        <td>{currencyFormatter({ value: item?.bonos })}</td>
        <td>{currencyFormatter({ value: item?.deduction })}</td>
      </tr>
    );
  };

  renderTotalsRow = (printData: any) => {
    const { isRTL, totals } = printData;
    return (
      <tr style={{ fontSize: 14, fontWeight: 'bold' }}>
        <td colSpan={3} style={{ textAlign: 'center' }}>
          {isRTL ? 'المجموع' : 'Total'}
        </td>
        <td>{currencyFormatter({ value: totals?.overtime })}</td>
        <td>{currencyFormatter({ value: totals?.bonos })}</td>
        <td>{currencyFormatter({ value: totals?.deduction })}</td>
      </tr>
    );
  };

  renderDivider = (x: number) => (
    <Grid item xs={12}>
      <Box m={x}></Box>
    </Grid>
  );
  render() {
    const { company, printData } = this.props;
    const { isRTL, rows } = printData;
    return (
      <table className="report-container">
        <thead className="report-header">
          <tr>
            <th className="report-header-cell">
              <div className="header-info">{this.renderHeader(company)}</div>
            </th>
          </tr>
        </thead>
        <tbody className="report-content">
          <tr>
            <td className="report-content-cell">
              <div className="main">
                <Box style={{ direction: isRTL ? 'rtl' : 'ltr' }}>
                  <Grid container spacing={0}>
                    <Grid item xs={12}>
                      <Box ml={8} mr={8}>
                        <Grid container spacing={2}>
                          {this.renderDivider(1)}
                          {this.renderTitle(printData)}
                          <table id="report" className="report-container">
                            <thead className="report-header">
                              {this.renderItemHeaderTable(isRTL)}
                            </thead>
                            <tbody className="report-content">
                              {rows?.map((item: any) =>
                                this.renderItemTable(item, isRTL)
                              )}
                              {this.renderTotalsRow(printData)}
                            </tbody>
                          </table>
                        </Grid>
                      </Box>
                    </Grid>
                  </Grid>
                </Box>
              </div>
            </td>
          </tr>
        </tbody>
        <tfoot className="report-footer">
          <tr>
            <td className="report-footer-cell">
              <div className="footer-info">
                <div className={'page-footer'}></div>
              </div>
            </td>
          </tr>
        </tfoot>
      </table>
    );
  }
}
